import script from "./shoplist.vue?vue&type=script&setup=true&lang=js"
export * from "./shoplist.vue?vue&type=script&setup=true&lang=js"

import "./shoplist.vue?vue&type=style&index=0&id=040df8c5&scoped=true&lang=scss"
import "./shoplist.vue?vue&type=style&index=1&id=040df8c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040df8c5"]])

export default __exports__